var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledEditd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 3,
    fill: "#F5F6F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 9.27148C26 9.70117 25.9186 10.1178 25.7559 10.5215C25.5931 10.9251 25.3555 11.2832 25.043 11.5957L12.1816 24.457L6 26L7.54297 19.8184L20.4043 6.95703C20.7168 6.64453 21.0749 6.4069 21.4785 6.24414C21.8822 6.08138 22.2988 6 22.7285 6C23.1777 6 23.6009 6.08789 23.998 6.26367C24.3952 6.43294 24.7402 6.66732 25.0332 6.9668C25.3327 7.25977 25.5671 7.60482 25.7363 8.00195C25.9121 8.39909 26 8.82227 26 9.27148ZM9.18359 19.9453C9.8737 20.1732 10.4661 20.5378 10.9609 21.0391C11.4622 21.5339 11.8268 22.1263 12.0547 22.8164L22.6113 12.25L19.75 9.38867L9.18359 19.9453ZM7.71875 24.2812L10.9316 23.4805C10.8665 23.181 10.7591 22.8978 10.6094 22.6309C10.4661 22.3639 10.2904 22.1263 10.082 21.918C9.8737 21.7096 9.63607 21.5339 9.36914 21.3906C9.10221 21.2409 8.81901 21.1335 8.51953 21.0684L7.71875 24.2812ZM23.5 11.3613C23.6628 11.1986 23.819 11.0456 23.9688 10.9023C24.1185 10.7591 24.252 10.6094 24.3691 10.4531C24.4863 10.2904 24.5775 10.1178 24.6426 9.93555C24.7142 9.74674 24.75 9.52865 24.75 9.28125C24.75 9.0013 24.6947 8.74089 24.584 8.5C24.4798 8.2526 24.3333 8.03776 24.1445 7.85547C23.9622 7.66667 23.7474 7.52018 23.5 7.41602C23.2591 7.30534 22.9987 7.25 22.7188 7.25C22.4714 7.25 22.2533 7.28581 22.0645 7.35742C21.8822 7.42253 21.7096 7.51367 21.5469 7.63086C21.3906 7.74805 21.2409 7.88151 21.0977 8.03125C20.9544 8.18099 20.8014 8.33724 20.6387 8.5L23.5 11.3613Z",
    fill: "#59637C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledEditd);
export default __webpack_public_path__ + "static/media/FilledEditd.402d2e5d03862485b6624903e1a8b221.svg";
export { ForwardRef as ReactComponent };